module.exports = __webpack_public_path__ + "img/66_11.9f24bf35.png";